module.exports = __webpack_public_path__ + "img/icon-warning-styrtregn-3.850181ac.svg";